import { render, staticRenderFns } from "./statusdisplay-component.vue?vue&type=template&id=306fdc41"
import script from "./statusdisplay-component.vue?vue&type=script&lang=ts"
export * from "./statusdisplay-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports